import ChartUpIcon from 'images/dashboard/chart-up.svg';
import ChartDownIcon from 'images/dashboard/chart-down.svg';

const GrowthChip = ({
    value = "N/A",
    description = null,
    isPositive = true,
    isPercent = false
}) => {
    return (
        <div className="flex flex-col items-center ">
            <div className={`inline-flex gap-1 items-center rounded-md py-[6px] px-2 ${isPositive ? 'bg-green-100' : 'bg-red-100'}`}>
                <span className={`text-base font-medium ${isPositive ? 'text-green-600' : 'text-red-600'}`}>
                    {isPositive ? '+ ' : '- '}
                    {Math.abs(value)}
                    {isPercent ? '%' : ''}
                </span>
                <img src={isPositive ? ChartUpIcon : ChartDownIcon} alt="" className="h-3 w-3" />
            </div>
            {
                description ? (
                    <p className={`text-[8px] font-normal leading-none ${isPositive ? 'text-green-600' : 'text-red-600'}`}>{description}</p>
                ) : null
            }
        </div>
    );
};

export default GrowthChip;